import {
  OnInit,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  ChangeDetectionStrategy,
  AfterContentChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbDateStruct,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { BookTimingModalComponent } from '../../book-timing-modal/book-timing-modal.component';

import Swal from 'sweetalert2';
import moment from 'moment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import {
  filter,
  interval,
  Observable,
  Subscription,
  takeUntil,
  timer,
  Subject,
} from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { DOCUMENT } from '@angular/common';
import e, { response } from 'express';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { LinkShareComponent } from '../../link-share/link-share.component';
import { TagSelectorComponent } from '../../community/tag-selector/tag-selector.component';
import { stat } from 'node:fs';
import { MarketplacePageComponent } from '../marketplace.component';
import { suggestions } from './view-product.interface';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { Overlay } from '@angular/cdk/overlay';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { MyProductEditComponent } from '../../my-product-edit/my-product-edit.component';
import { PollFormComponent } from 'src/app/poll-form/poll-form.component';
import { PopUpService } from 'src/app/popupservice.service';
import { MarketplaceShopDetailComponent } from '../shop-detail/marketplace-shop-detail.component';
import { ProductShopComponent } from 'src/app/product-shop/product-shop.component';
import { ContributeToProductComponent } from 'src/app/contribute-to-product/contribute-to-product.component';
import { FollowService } from 'src/app/follow.service';
import { title } from 'node:process';
import { ShowBookingsComponent } from 'src/app/nearby-map/show-bookings/show-bookings.component';
import { Location } from '@angular/common';

declare const google: any;
@Component({
  selector: 'app-view-product-details',
  templateUrl: './view-product-details.component.html',
  styleUrls: [
    './view-product-details.component.scss',
    '../marketplace.component.scss',
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewProductDetailsComponent
  implements OnChanges, AfterViewInit, OnDestroy, OnInit, AfterContentChecked
{
  @Input() addProductComponent?: any = null;
  @Input() modal: any;

  @Input() productData: any;
  @Input() productLoader: boolean | null = false;
  @Output() updated = new EventEmitter<any>();

  public isShowingMoreVariants = false;
  public currentImageCropInfo = null;
  public productImageCropInfos = [null, null, null, null];
  /***************************** Code related to similar products  ****************************/
  @ViewChild('seeProductList')
  seeProductList: TemplateRef<any>;
  public currentModaRef?: NgbModalRef | null | MatBottomSheetRef = null;
  public searchProds = [];
  public prodsSwiper = null;
  public set lockSwipe(val: boolean) {
    //console.log(this.prodsSwiper)
    if (val) {
      //console.log('disablign swipe')
      this.prodsSwiper?.disable();
    } else {
      //console.log('enabling sipwe')
      this.prodsSwiper?.enable();
    }
  }

  public openSimilarProducs(type) {
    this.productListTitle = ' Similar Products';
    this.productListIcons = 'fa-solid fa-handshake';
    this.auth
      .fetchProductsBasedOnTypes({ types: Array.from([type.id]) })
      .subscribe({
        next: (data: any) => {
          this.searchProds = data.data;
          this.isSearchProductsOnBookmark = false;
          this.currentModaRef = this.popup.openPopup(this.seeProductList, {
            modalSize: 'md',
            forceMode: 'modal',
            noHistory: true,
          });
          //this.modalService.open(this.seeProductList, {
          //     size: 'md',
          // });
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error something went wrong while fetching ');
        },
      });
  }
  /************************************************************************************** */
  public shopImageSwiper = null;
  get totalLength() {
    return [
      this.productData?.food_image_1,
      this.productData?.food_image_2,
      this.productData?.food_image_3,
      this.productData?.food_image_4,
    ].reduce((a, b) => a + (b ? 1 : 0), 0);
  }
  get activeLength() {
    return (this.shopImageSwiper?.activeIndex ?? 0) + 1;
  }

  // getter used by *ngFor to create an iterable of the right length
  get segments(): undefined[] {
    return Array.from({ length: Math.max(0, this.totalLength) });
  }

  // trackBy for performance
  trackByIdx(index: number): number {
    return index;
  }

  detectChange() {
    this.cdr.detectChanges();
  }

  /******************************************************************************************/
  /**************************** Code related to similar products and swiper for that ********/
  private _loadSameCategoryProducts() {
    if (this.productData?.isTypeShop) {
      this.similarProducts = [];
      return;
    }
    if (
      this.similarProducts?.length ||
      !(
        this.sharedService.isBrowser() &&
        this.window?.location.href.includes('product=')
      ) //if it's on page don't load
    ) {
      return; //cause can be passed from popup to product page
    }
    this.customerService
      .getMemberShopProductList({
        categoryId: this.productData?.categoryId,
        limit: 5,
        // includeTypes: true,
      })
      .subscribe({
        next: (data) => {
          if (!Array.isArray(data?.body?.data)) {
            return;
          }

          this.similarProducts = data?.body?.data?.filter(
            (prod) => prod && prod.id != this.productData?.id,
          );
          this._loadMoreInfos();
        },
        error: console.error,
      });
  }

  @Input()
  public similarProducts = [];

  /******************************Types and Faqs *****************************/
  public faqsExist = true;
  public typesExist = true;
  public isInitDone = false;
  public carOptions = {
    slidesPerView: 1,
    //spaceBetween: 10,
    initialSlide: 1,
  };

  /************************************************************************* */

  //public ownerTelegramUsername: any = 0;
  public appUserId: any = 0;
  public sellerInfo: SafeHtml;
  public store_link_prefix: any = 'fusionapp.store';
  public default_store_link_prefix: any = 'fusionapp.store';
  public isTypeReferral: any;
  public refer_friend_link: any;
  public imgUrl = environment.ImageUrl;
  public suggestionBase64: any = null;
  public productSuggestions: any = [];
  public type: string = '';
  public memberMessage: string = '';
  public reportType: string = 'Spam';
  public suggestionAttachment: any = null;
  public errorChatURL: boolean = false;
  public messsage: string = '';
  public isMessageSent: boolean = false;
  public isBookNowBox: boolean = false;
  public isMessageBox: boolean = false;
  public profileInfo2: any;
  public profile: any = {};
  public memberProductList: Array<any> = [];
  public endTime: any = '';
  public timer: any = null;
  public isLogin: any = 0;
  public screenWidth: any = 0;
  public today = new Date();
  public bookNowBoxMesssage: string = '';
  public isLoading: boolean = false;
  public categoryFAQsExist = true;
  public recommendTabIndex = 0;
  public selectedShopTabIndex = 0;
  public doesUserOwnThisProduct = false;

  //public tabsRecommend: any = [];
  public maps: any = {};
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = '';

  public destroy$ = new Subject<void>();
  public user: any;
  public isUserDisabled: boolean = false;
  public ownerTelegramUserName = '';
  public isExpandedDescription: boolean = false;
  @ViewChild('product_content') product_content: ElementRef;
  productSeeMore: boolean = false;
  canScrollDescription: boolean = false;

  public iconsSwiperOptions = {
    //slidesPerView: 4,
    //spaceBetween: 10,
    nested: true,
  };

  public specialTags = new Set([
    'Preferred',
    'Top Seller',
    'Freelance',
    'Chain',
  ]);
  public prodSwiperConfig = {
    autoHeight: false,
  };

  openPollModal() {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    const ref = this.popup.openPopup(PollFormComponent, {
      modalSize: 'sm',
      modalArialLabelBy: 'modal-basic-title',
      modalWindowClass: 'my-modal md',
      forceMode: 'modal',
      noHistory: true,
    }) as NgbModalRef;
    // this.modalService.open(PollFormComponent, {
    //   size: 'sm',
    //   // backdrop: 'static',
    //   ariaLabelledBy: 'modal-basic-title',
    //   windowClass: 'my-modal md',
    // });
    // this.poll = {
    //   isLoading: false,
    //   name: '',
    //   startDate: '',
    //   endDate: '',
    //   polls: [],
    // };
    ref.componentInstance.productId = this.productData?.id;
  }

  public carouselOptions: any = {
    pagination: false,
    loop: true,
    nested: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    touchStartPreventDefault: false,
    passiveListeners: false,
  };
  carouselOptionsTags: any = {
    slidesPerView: "auto",
    pagination: false,
  };
  //////////////////////////////// Code related to bookmarks ///////////////////////////////////
  public addProductToBookmarks(prod) {
    const rv = this.local.addProductToBookMark(prod);
    if (rv === -1) {
      this.toastr.info('Maximum bookmark length');
    }
  }
  public removeProductFromBookmarks(prod) {
    this.local.removeProductFromBookMarks(prod);
  }
  public bookmarkedProductsIds = new Set();
  public bookMarkSubscrption?: Subscription | null = null;
  ////////////////////////////////////////////////////////////////////////////////////////

  public get productHasFAQ(): boolean {
    return (
      (typeof this.productData?.faqInfos == 'string' &&
        this.productData?.faqInfos?.length > 3) ||
      (Array.isArray(this.productData?.faqInfos) && this.productData?.length)
    );
  }
  timeout1: any;
  constructor(
    private http: HttpClient,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private clipboard: Clipboard,
    private memberNotificationService: MemberNotificationService,
    private _sanitizer: DomSanitizer,
    private sharedService: SharedService,
    public roleService: RoleService,
    private customerService: CustomerService,
    private router: Router,
    private store: Store<AppState>,
    private seoService: SeoService,
    private renderer2: Renderer2,
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private cdr: ChangeDetectorRef,
    public commonService: CommonService,
    private location: Location,
    // private activeModal: NgbActiveModal,
    private overlay: Overlay,
    @Inject('WINDOW') private window: any,
    private popup: PopUpService,
    private followService: FollowService,
  ) {
    this.screenWidth = this.window?.innerWidth;
    //this.checkIfLogin();

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((response: User) => {
        this.profileInfo2 = response;
        this.currentUserPoints = this.profileInfo2?.points ?? '0';
        ////////console.log('profile is', this.profileInfo2)
      });

    if (this.productData?.seller && !this.productData?.seller?.w_phone_number) {
      this.productData.seller.buyerContact = 1;
    }

    this.timeout1 = setTimeout(() => {
      this.checkDescriptionScroll();
    }, 4000);
    // setTimeout( () =>this.getTelegramUsernameOfUser(this.productData?.appUser?.id), 800);
  }

  private descrScrollRun = false;
  ngAfterContentChecked(): void {
    if (!this.descrScrollRun) {
      this.checkDescriptionScroll(false);
      this.descrScrollRun = true;
    }
  }

  openSuggestionPopup(productData) {
    let ref = this.popup.openPopup(TagSelectorComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      hasBackdrop: true,

      modalSize: 'sm',
      modalWindowClass: 'tags-modal',
      modalIsCenter: true,
      noHistory: true,
    });
    if (this.isMobile) {
      ref = ref as MatBottomSheetRef;
      ref.instance.productId = productData.id;
      ref.instance.isBottomSheet = true;
      ref.instance.fetchTagInfos();
      return ref;
    } else {
      ref = ref as NgbModalRef;
      ref.componentInstance.productId = productData.id;
      return ref;
    }

    // if (this.isMobile) {
    //   const ref = this.bottomSheet.open(TagSelectorComponent, {
    //     panelClass: 'bottom-sheet-1',
    //     scrollStrategy: this.overlay.scrollStrategies.block(),
    //     hasBackdrop: true,
    //   });
    //   ref.instance.productId = productData.id;
    //   ref.instance.isBottomSheet = true;
    //   ref.instance.fetchTagInfos();
    //   return ref;
    // } else {
    //   const ref = this.modalService.open(TagSelectorComponent, {
    //     size: 'sm',
    //     windowClass: 'tags-modal',
    //     centered: true,
    //   });
    //   ref.componentInstance.productId = productData.id;
    //   return ref;
    // }
  }
  openSuggestionPopupAndRefresh(productData) {
    const ref = this.openSuggestionPopup(productData);
    if (ref instanceof NgbModalRef) {
      ref.closed.subscribe(() => {
        this._refreshData();
      });
    } else if (ref instanceof MatBottomSheetRef) {
      ref.afterDismissed().subscribe(() => {
        this._refreshData();
      });
    }
  }
  public removeTagFromProduct(tag) {
    this.auth.removeTagFromProduct(tag.tag, this.productData.id).subscribe({
      next: () => {
        this._loadMoreInfos();
        this.toastr.success('Removed tag');
        tag.isAddedByMe = !tag.isAddedByMe;
        tag.addCount -= 1;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while adding tag');
      },
    });
  }
  public addTagToProduct(tag) {
    //////console.log({ tag })
    this.auth
      .addTagToProduct(tag.tag, null, this.productData.id, this.isAdmin)
      .subscribe({
        next: () => {
          this.toastr.success('Added tag');
          tag.addCount += 1;
          tag.isAddedByMe = !tag.isAddedByMe;
          this._loadMoreInfos();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while adding tag');
        },
      });
  }
  public tags = [];
  private loadTags(productData) {
    if (!productData) {
      console.warn('error productData is invalid', productData);
    }

    this.auth.getTagsOfProduct(productData?.id).subscribe({
      next: (data: any) => {
        productData.tags = data.data;
      },
      error: console.error,
    });
  }

  public closeActiveModal() {
    if (typeof this.currentModaRef?.dismiss == 'function') {
      this.currentModaRef?.dismiss();
    }
  }
  public glowNextPage() {
    this.glowPageNumber = 2;
    this.cdr.detectChanges();
  }
  public submitGlowQuestion() {
    this.glowPageNumber = 3;
    this.auth
      .addMemberProductReview({
        memberProductId: this.productData?.id,
        wouldRecommend: this.glowWouldRecommend,
        whyRecommend: this.glowWhyRecommend,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Added!');
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
    this.cdr.detectChanges();
  }
  public productListTitle = 'Similar Products';
  public productListIcons = 'fa-solid fa-bookmark';
  private editProductIdSubjectSubscirption: Subscription | null = null;
  public searchProductSelected(isSelectedNow, productData) {
    if (this.isSearchProductsOnBookmark) {
      if (isSelectedNow) {
        this.local.addProductToBookMark(productData);
        this.toastr.success('Added to bookmarks');
      } else {
        this.local.removeProductFromBookMarks(productData);
        this.toastr.success('Removed from bookmarks');
      }
    }
  }
  public openSaveBookMarks() {
    this.productListTitle = ' Bookmarked Products';
    this.productListIcons = 'fa-solid fa-bookmark';
    this.searchProds = this.local.bookMarkedProducts.value;
    this.isSearchProductsOnBookmark = true;
    this.currentModaRef = this.popup.openPopup(this.seeProductList, {
      modalSize: 'md',
      forceMode: 'modal',
      noHistory: true,
    }); //this.modalService.open(this.seeProductList, { size: 'md' });
  }

  timeout2: any;
  ngOnInit(): void {
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.isAdmin = response?.userType?.includes('ADMIN');
        this.cdr.detectChanges();
      });
    this.mainProductData = this.productData;
    this.loadTypeOfProduct(this.productData);
    if (this.sharedService.isBrowser()) {
      // setTimeout(() =>this.loadTags(), 2000);
      // setTimeout(() =>this.loadRatings(), 2000);
      this.isLoading = true;
      this._processCropInfos();
      //this.openGlowAskModal()
      if (this.beginExplanationTimeout) {
        clearTimeout(this.beginExplanationTimeout);
      }
      this.beginExplanationTimeout = setTimeout(() => {
        if (this.sharedService.isBrowser()) {
          this.beginExplanationInterval();
        }
      }, 1_000); //CHANGE_BACK 1_000

      this.bookMarkSubscrption = this.local.bookMarkedProducts
        .asObservable()
        .subscribe((val) => {
          //console.log({val})
          this.bookmarkedProductsIds = new Set(val.map((b) => b.id));
        });
      this._getAssignedRewardAmount();

      this.editProductIdSubjectSubscirption =
        this.sharedService.editProductIdSubject.subscribe({
          next: (productId) => {
            const userId = this.local.getUser()?.id;
            if (
              productId == this.productData?.id ||
              (!productId &&
                this.isPopup &&
                userId == this.productData?.memberId)
            ) {
              this.editMemberProduct();
            }
          },
        });
    }

    if (this.sharedService.isBrowser()) {
      this._loadMoreInfos();

     
    }
    this.checkIfLogin();
    console.log('isAd=', this.productData?.isAd);
  }
  public loadTimeAgo(prod) {
    prod.timeAgo = this._timeAgo(prod?.updated);
  }
  public _timeAgo(dateInput): string {
    if (!dateInput) return 'Invalid date';

    let date: Date;

    // Handle Unix timestamp (seconds vs milliseconds)
    if (typeof dateInput === 'number') {
      date = new Date(dateInput < 1e12 ? dateInput * 1000 : dateInput);
    } else {
      date = new Date(dateInput);
    }

    if (isNaN(date.getTime())) return 'Invalid date';

    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 0) return 'In the future';

    const intervals: { [key: string]: number } = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
      const interval = Math.floor(seconds / secondsInUnit);
      if (interval >= 1) {
        return `${interval} ${unit}${interval > 1 ? 's' : ''} ago`;
      }
    }

    return 'Just now';
  }

  private nullCheck(value: any): string {
    if (value === null || value === 'null' || value === '') {
      return '';
    }
    return value;
  }
  public isTherePrice(productData) {
    return (
      (productData?.memberShopProductsVariations?.length > 0 &&
        productData?.type != 'promote') ||
      (productData?.['foodSpecs']?.length > 0 &&
        productData?.['foodSpecs'].some((x) => x.key != '$0' && x.key != '0'))
    );
  }
  private _loadTabsRecommends(productData) {
    if (!productData) {
      return;
    }
    productData.tabsRecommend = [];
    if (this.productData.enableMemberShop &&!this.productData?.isTypeShop) {
      //if main one is enabled the others are too
      productData['tabsInfo'] = [
        // {
        //   title: "Price",
        //   icon: "fa-solid fa-dollar-sign",
        //   condition: ( (productData.memberShopProductsVariations?.length > 0 && productData.type != 'promote')
        //   || productData?.["foodSpecs"]?.length > 0 && productData?.["foodSpecs"].some(x => x.key != '$0'  && x.key != '0'))// && productData.type != "promote",
        // },
        {
          title: "services provided",
          icon: "fa-solid fa-bell-concierge",
          condition: productData?.tags?.length || productData?.productTypes?.size
        },
        {
          title: 'Info',
          icon: 'fa-solid fa-circle-info',
          condition:
            this.isLogin ||
            productData?.hasReview ||
            productData?.description != '' ||
            (productData?.memberShopProductsVariations?.length > 0 &&
              productData?.type != 'promote') ||
            (productData?.['foodSpecs']?.length > 0 &&
              productData?.['foodSpecs'].some(
                (x) => x.key != '$0' && x.key != '0',
              )),
        },
        {
          title: 'Detail',
          // icon: 'fa-solid fa-circle-info',
          condition:
            productData.charges != '' &&
            productData.charges != undefined &&
            productData.charges != 'null' &&
            productData.charges != '-',
        },

        {
          title: 'Rent',
          // icon: 'fa-solid fa-circle-info',
          condition:
            productData?.type == 'rental' &&
            (productData?.depositAmt ||
              productData?.estimateValue ||
              productData?.warranty),
        },
        // {
        //   title: 'Contact',
        //   icon: 'fa-solid fa fa-phone',
        //   condition:
        //     productData?.type == 'promote' &&
        //     (productData?.roleName?.includes('SUPER SELLER') ||
        //       productData?.roleName?.includes('ADMIN')) &&
        //     (this.nullCheck(productData?.shoutContactRelation) ||
        //       this.nullCheck(productData?.shoutWebsite)),
        // },
        {
          title: 'How To',
          icon: 'fa-solid fa-question',
          condition: this.productData?.type == 'promote' && this.howTos?.length,
        },
        // {
        //   title: productData?.subRegionName?.trim() ?? 'Location',
        //   icon: 'fa-solid fa-location',
        //   condition:
        //     (productData?.type == 'promote' &&
        //       productData?.latLong != '{}' &&
        //       productData?.latLong != null) ||
        //     (productData?.type != 'promote' &&
        //       productData?.appUser?.postalCode != null),
        // },
      ];

      productData.tabsRecommend = [
        {
          title: `Experiences(${productData?.xpCount ?? 0})`,
        },
        {
          title: 'Promo',
          // condition: productData?.productMoreServices?.length > 0
          condition: false, //now removed and shifted up to description
        },
        {
          title: 'Profile',
          //  icon: 'fa-solid fa-user'
        },
        {
          title:
            'Comments' +
            (productData?.enableMemberShop && productData?.forum?.repliesCount
              ? `(${productData?.forum?.repliesCount})`
              : ''),
        },
        {
          title: 'More Products',
          // icon: '',
          condition: productData?.more_products_data?.length > 0,
        },
        {
          title: 'Socials',
          // icon: 'fa-solid fa-star',
          condition:
            productData['sellerInformation']?.fbReviewUrl ||
            productData['sellerInformation']?.carousellReviewUrl ||
            productData['sellerInformation']?.googleReviewUrl ||
            productData['sellerInformation']?.websiteUrl ||
            productData['sellerInformation']?.instagramUrl ||
            productData['sellerInformation']?.fbUrl,
        },
        {
          title: 'FAQ',
          condition: this.productHasFAQ,
        },
      ];
    }
    //console.log(productData?.name, productData?.tabsRecommend)
  }
  private checkAndGlow(prod) {
    if (!prod) {
      return;
    }
    if (prod == this?.productData) {
      if (!prod?.myReview) {
        prod.myReview = {};
      }
      if (this.sharedService.isBrowser()) {
        const myReview = prod?.myReview;
        if (this.productData?.glowPoints && !myReview?.wouldRecommend) {
          this.openGlowAskModal();
          prod.myReview.wouldRecommend = 1;
        }
      }
    }
    ///need to make sure myReview is fetched
  }

  private _loadMostReviewedOptionsOfProduct(prod) {
    this.auth.getMostReviewedOptionOfProduct(prod?.id).subscribe({
      next: (data) => {
        prod.publicReviews = data.body.calcData;
        prod.totalCount = data.body.totalCount;
        prod.myReview = data.body.myReview;
        this.checkAndGlow(prod);
        this._checkIfHightlightsExist();
      },
      error: console.error,
    });
  }
  public getPercentage(field) {
    if (!this.productData?.publicReviews) {
      return 0;
    }
    return (
      ((this.productData?.publicReviews[field.name + 'Count'] ?? 0) /
        this.productData?.totalCount) *
      100
    );
  }

  suggestions = suggestions;
  public doHightlightsExist = false;
  private _checkIfHightlightsExist() {
    for (const field of this.suggestions) {
      if (this.getPercentage(field) >= 70) {
        this.doHightlightsExist = true;
        break;
      }
    }
  }
  private _loadMoreInfos() {
    //console.trace('_loadMoreInfos', this.similarProducts)

    for (const prod of [this.productData, ...this.similarProducts]) {
      if (!prod) {
        console.warn('invalid prod', prod);
        continue;
      }
      if (prod && this.mainProductEnableMemberShop !== undefined) {
        prod.enableMemberShop = this.mainProductEnableMemberShop;
        this.loadOtherImagesOfProduct(prod);
        this.loadTags(prod);
        this.loadTypeOfProduct(prod);
        this.loadRatings(prod);
        this._loadMostReviewedOptionsOfProduct(prod);
        this._loadTabsRecommends(prod);
        this.loadTimeAgo(prod);
        this.loadApprovedHowTo();
        this._sanitizeYoutubeIframes();
      }
    }

    this.isLoading = false;
  }
  public get isPopup(): boolean {
    return this.window?.location.href.includes('?product');
  }
  public howTos = [];
  public loadApprovedHowTo() {
    this.auth.getApprovedHowTos(this.productData?.id).subscribe({
      next: (data) => {
        this.howTos = data.body;
        this._loadTabsRecommends(this.productData);
        this.cdr.markForCheck();
      },
      error: console.error,
    });
  }

  private closeExplanation() {
    this.sharedService.showAIExplanationForProductSubject.next({
      explainText: '',
      closeAll: true,
    });
  }
  openCorrectedSite(url: string) {
    ////////console.log({url})
    if (url?.trim()) {
      Swal.fire({
        title: 'Open link',
        text: 'Open link a in a new tab?',
        icon: 'info',
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          this.window?.open(this.correctSite(url), '_blank');
        } else {
        }
      });
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.editProductIdSubjectSubscirption?.unsubscribe();
    this.bookMarkSubscrption?.unsubscribe();
    this._secsIntervalSubscription?.unsubscribe();
    this._secsTimerSubscription?.unsubscribe();
    this.local.clearTimeout(this.timeout1);
    this.local.clearTimeout(this.timeout2);
    this.local.clearTimeout(this.timeout3);
    this.local.clearTimeout(this.timeout4);
    this.local.clearTimeout(this.timeout5);
    this.local.clearTimeout(this.timeout6);
    this.local.clearTimeout(this.timeout7);

    if (this.sharedService.isBrowser()) {
      //////console.log('destroy called')
      const synth = window?.speechSynthesis;
      synth.cancel();

      this.disposeExplanationInterval();
      this.closeExplanation();
      if (this.productData) {
        this.productData.ratings = [];
      }
    }
  }
  public currentProductTogglePopuplarInSubRegion() {
    this.auth
      .toggleProductIsPopuplarInSubRegion(this.productData?.id)
      .subscribe({
        next: () => {
          this.toastr.success('Changed');
        },
        error: (err) => {
          this.toastr.error(err.error.message);
        },
      });
  }

  public get isVerySmall() {
    return this.sharedService.isBrowser() && window?.innerWidth <= 434;
  }

  // public otherRatingBadges = []
  private loadRatings(pd) {
    if (!pd) {
      return;
    }
    pd.ratings = [];
    pd.otherRatingBadges = [];

    if (pd && pd.isPopuplarInSubRegion) {
      //console.log('product is popular in subregion')
      pd.otherRatingBadges.push({
        icon: 'adopt.png',
        topText: 'Popular in ',
        bottomText: pd.subRegionName ?? '',
        isNormalBadge: true,
      });
    }

    if (pd && pd['seller_info']) {
      ////console.log('loading ratings on', pd.name)

      let sellerInfo = pd['seller_info'];
      ////////console.log('seller_info is in productData', sellerInfo) //DELETE LATTER
      ////////console.log('seller info is ', sellerInfo)
      if (!sellerInfo) {
        console.warn('no sellerinfo');
        return;
      } else {
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(sellerInfo);
        }
        ////console.log(pd.name, sellerInfo)
      }

      if (sellerInfo['googleReviewRating']) {
        pd.ratings.push({
          id: 'ggle',
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount,
        });
      }
      if (sellerInfo['fbReviewRating']) {
        pd.ratings.push({
          id: 'fb',
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount,
        });
      }

      if (sellerInfo['carousellReviewRating']) {
        pd.ratings.push({
          id: 'car',
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount,
        });
      }

      const otherToolTips = `Claims are determined from various sources such as:
      1. Online Reviews 
      2. Real-life Testimonials 
      3. Customer feedback survey`;

      if (sellerInfo['superDealRating']) {
        pd.otherRatingBadges.push({
          icon: 'super_deal_1.png',
          name: 'Super Deal',
          rating: sellerInfo.superDealRating,
          text: sellerInfo.superDealText,
          toolTip: otherToolTips,
        });
      }

      if (sellerInfo['bestPriceRating']) {
        pd.otherRatingBadges.push({
          icon: 'best_price_1.png',
          name: 'Best Price',
          rating: sellerInfo.bestPriceRating,
          text: sellerInfo.bestPriceText,
          toolTip: otherToolTips,
        });
      }

      if (sellerInfo['highQualityRating']) {
        pd.otherRatingBadges.push({
          icon: 'high_quality_1.png',
          name: 'Hight Quality',
          rating: sellerInfo.highQualityRating,
          text: sellerInfo.highQualityText,
          toolTip: otherToolTips,
        });
      }
    }
    if (pd) {
      pd.ratings = structuredClone(pd.ratings);
    }
    if (pd.otherRatingBadges) {
      pd.otherRatingBadges = structuredClone(pd.otherRatingBadges);
    }

    ////////console.log('ratings are ', this.ratings)
  }

  private abortController: AbortController | null = null;
  private fetchSummarySubsctiption: Subscription | null = null;

  private explanationInterVal = null;
  private explanations = [];
  private currentExplantaionIndex = 0;
  private showNextExplanation() {
    this.sharedService.showAIExplanationForProductSubject.next({
      explainText:
        this.explanations[
          this.currentExplantaionIndex++ % this.explanations.length
        ],
      isExplanationProductClaimable: this.showReferProductIcon,
    });
  }
  private beginExplanationInterval() {
    if (this.explanationInterVal) {
      clearInterval(this.explanationInterVal);
    }
    this.fetchSummarySubsctiption?.unsubscribe();

    this.fetchSummarySubsctiption = this.customerService
      .getProductSummary(
        this.productData?.id,
        !(
          this.productData &&
          typeof this.productData === 'object' &&
          'appUser' in this.productData
        ),
      )
      .subscribe({
        next: (data) => {
          this.fetchSummarySubsctiption = null;

          this.explanations = data.data;
          if (!this.explanations.length) {
            console.warn('No explanations for product found!');
            return;
          }

          this.showNextExplanation();
          this.explanationInterVal = setInterval(() => {
            this.showNextExplanation();
          }, 15_000); //CHANGE_BACK 10_000
        },
        error: (err) => {
          console.error(err);
          this.fetchSummarySubsctiption = null;
        },
      });
  }
  private disposeExplanationInterval() {
    if (this.beginExplanationTimeout) {
      clearTimeout(this.beginExplanationTimeout);
      this.beginExplanationTimeout = null;
    }
    this.fetchSummarySubsctiption?.unsubscribe(); //if any calls tot he previous product just don't show it anymore
    if (!this.explanationInterVal) return;
    clearInterval(this.explanationInterVal);
    this.explanationInterVal = null;
  }

  private beginExplanationTimeout = null;
  ngAfterViewInit(): void {}

  private readonly PRODUCT_IMAGE_LEN = 4;
  private _processCropInfos() {
    let key = '';
    for (let i = 1; i <= this.PRODUCT_IMAGE_LEN; i++) {
      let cropInfo = null;
      if (i == 1) {
        cropInfo = this.productData?.mainImageCropInformation;
      } else {
        cropInfo = this.productData?.otherImagesCropInfo;
        key = `image${i}`;
      }

      if (typeof cropInfo == 'string') {
        try {
          cropInfo = JSON.parse(cropInfo);
        } catch (e) {
          console.error(e);
        }
      }

      if (key && cropInfo) {
        cropInfo = cropInfo[key];
      }
      this.productImageCropInfos[i - 1] = cropInfo;
    }
    // console.log('cropInfos', this.productImageCropInfos)
    this.currentImageCropInfo = this.productImageCropInfos[0];
  }
  public youtubeIframes = [];
  private _sanitizeYoutubeIframes() {
    this.youtubeIframes = [];
    if (
      this.productData?.additionalTag != 'Youtube' ||
      !this.productData?.linked?.trim()
    ) {
      return;
    }

    for (const iframe of this.productData?.linked?.trim()?.split('\n')) {
      if (iframe?.trim()?.startsWith('<iframe')) {
        this.youtubeIframes.push(this.sanitizeHTML(iframe));
      }
    }
  }
  public performFollowAction() {
    let action: any = 'follow';
    if (this.amIFollowingTheOwner) {
      action = 'unfollow';
    }
    this.auth
      .performFollowAction(this.productData?.appUser?.id, action)
      .subscribe({
        next: () => {
          // this._refreshData()
          if (this.amIFollowingTheOwner) {
            this.productData.appUser.followers = [];
          } else {
            this.productData.appUser.followers = [this.local.getUser()?.id];
          }

          this.followService.getFollowData();
          this.sharedService.refreshProductId.next({
            action: 'edited',
            productId: this.productData?.id,
          });
        },
        error: (error) => {
          this.toastr.error(error.error.message ?? 'Something went wrong');
        },
      });
  }
  public get amIFollowingTheOwner() {
    return this.productData?.appUser?.followers?.length; //since this follower might only contain this appUser
  }
  private _setCropInfoForCurrentImage() {
    let imageNum = 1;

    for (; imageNum < this.PRODUCT_IMAGE_LEN; imageNum++) {
      if (
        this.productData?.food_image_active ==
        this.productData[`food_image_${imageNum}`]
      ) {
        this.currentImageCropInfo = this.productImageCropInfos[imageNum - 1];
        break;
      }
    }
  }
  public sanitizeHTML(html: string) {
    return this.commonService.sanitizeHTML(html);
  }

  private _updateUrlWithQueryParam(key: string, value: string | null): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const url = new URL(window.location.href);

    if (value === null) {
      // Remove the query parameter
      url.searchParams.delete(key);
    } else {
      // Add or update the query parameter
      url.searchParams.set(key, value);
    }

    // Build the new URL preserving existing query params
    const newQueryString = url.searchParams.toString();
    const basePath = window.location.pathname;
    const newUrl = newQueryString ? basePath + '?' + newQueryString : basePath;
    this.location.replaceState(newUrl);
  }

  public openProductShopPage() {
    const instance = this.popup.openPopup(ProductShopComponent, {
      //  forceMode: 'bs',
      noHistory: true,
      bottomSheetPanelClass: 'bottom-sheet-2',
      hasBackdrop: true,
      modalSize: 'md',
      modalModalClass: 'shop-page-popup',
    });

    this._updateUrlWithQueryParam('openShop', '1');

    this.auth
      .getShopProductDetails({ productId: this.productData?.id, isForPage: 1 })
      .subscribe({
        next: (data) => {
          if (this.sharedService.isOnMobile) {
            (instance as MatBottomSheetRef).instance.serviceData = data.body;
          } else {
            (instance as NgbModalRef).componentInstance.serviceData = data.body;
          }

          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error could not find the product data');
        },
      });
  }
  public openProductPage(productData) {
    //console.log({productData})
    //[routerLink]="['/product', productData?.slug]"
    this.router.navigate(['/product', productData?.slug], {
      state: {
        passedProductData: structuredClone(productData),
        similarProducts: this.similarProducts ?? [],
      },
    });
  }

  public isReading = false;
  private nowReadingText = '';

  public pause() {
    const synth = speechSynthesis;

    if (synth.speaking && !synth.paused) {
      ////////console.log("Pausing read");
      speechSynthesis.pause();
      this.isReading = false;
    } else {
      //////console.log("Cannot pause, either not speaking or already paused");
    }
  }

  public async read(text) {
    const synth = window?.speechSynthesis;
    if (synth.speaking && this.nowReadingText != text) {
      await synth.cancel();
    }
    if (synth.speaking && this.nowReadingText === text) {
      await synth.resume();
    }
    this.nowReadingText = text;

    const userAgent = navigator.userAgent;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1;

    const voices = speechSynthesis.getVoices();

    let voice = null;

    if (
      userAgent.includes('Chrome') &&
      !userAgent.includes('Edg') &&
      !userAgent.includes('OPR') &&
      !userAgent.includes('Brave')
    ) {
      //////console.log('choosing a device on chrome or edge')
      const cand = voices.find(
        (voice) =>
          voices.find(
            (voice) =>
              voice.name.toLowerCase().includes('moira') ||
              voice.lang === 'en-SG',
          ) ||
          voice.name.includes('Female') ||
          (voice.lang.includes('en') && voice.name.includes('Google')),
      );
      if (cand) {
        voice = cand;
      }
      //////console.log('Picked voice for chrome ', voice)
    }
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      const cand = voices.find((voice) => voice.name.includes('Siri'));
      if (cand) {
        voice = cand;
      }
    }
    if (voice) {
      utterance.voice = voice;
    }

    this.isReading = true;
    speechSynthesis.speak(utterance);
    utterance.onend = () => {
      this.isReading = false;
    };
  }
  showAllVerfications: boolean = false;
  public get isVerified(): boolean {
    return (
      this.productData?.productVerficationsList &&
      this.productData?.productVerficationsList?.length > 0
    );
  }

  timeout7: any;
  checkDescriptionScroll(turnOffSeeMore = true) {
    if (this.sharedService.isBrowser()) {
      const LOC = (element: Element) => {
        const style = this.window?.getComputedStyle(element);
        const lineHeight = parseFloat(style.lineHeight);
        const height = element.clientHeight;

        return Math.floor(height / lineHeight);
      };
      const hasVerticalOverflow = (element: Element) => {
        return element.scrollHeight > element.clientHeight;
      };
      this.local.clearTimeout(this.timeout2);
      this.timeout7 = setTimeout(() => {
        const contentHeight = this.product_content?.nativeElement.scrollHeight;
        // console.log(
        //   'Called when',
        //   LOC(this.product_content?.nativeElement),
        //   hasVerticalOverflow(this.product_content?.nativeElement)
        // );
        if (
          LOC(this.product_content?.nativeElement) > 2 ||
          hasVerticalOverflow(this.product_content?.nativeElement)
        ) {
          this.canScrollDescription = true;
          if (turnOffSeeMore) {
            this.productSeeMore = false;
          }
        }
      }, 500);
    }
  }
  public isSearchProductsOnBookmark = false;

  public productSwiperChanged(swiper) {
    if (swiper.activeIndex == 0) {
      this.productData = this.mainProductData;
    } else {
      this.productData = this.similarProducts[swiper.activeIndex - 1]; ///this way all code does not need change
    }

    this.checkDescriptionScroll();
  }

  public showingPop = false;
  public goToProduct(prod) {
    if (prod && this.mainProductEnableMemberShop !== undefined) {
      prod.enableMemberShop = this.mainProductEnableMemberShop;
      this.loadOtherImagesOfProduct(prod);
      this.loadTags(prod);
      this.loadTypeOfProduct(prod);
      this.loadRatings(prod);
      this._loadTabsRecommends(prod);
      this._loadTabsRecommends(prod);
    }

    this.productData = prod;
    this.currentModaRef?.dismiss();
  }

  private readonly onChangeListeners: any = [];
  public mainProductData = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['productData']) {
      this.mainProductData = this.productData;
      this.loadTypeOfProduct(this.productData);
      this._loadSameCategoryProducts();
      this._loadMoreInfos();

      this._processCropInfos();

      if (this.productData?.enableMemberShop) {
        //////console.log('forumData', JSON.stringify(this.productData?.forum),this.productData?.forum )
        this._loadTabsRecommends(this.productData);
      }
      this.checkDescriptionScroll(false);
      if(this.productData?.isTypeShop){
        setTimeout(()=>this.initMap());
         
      }

      this.route.queryParams.subscribe((params) => {
        this._updateUrlWithQueryParam('openShop', null);
        if (params['openShop'] == '1') {
          this.openProductShopPage();
        }
      });
    }
  }

  timeout3: any;
  async initMap() {
    this.geocoder = new google.maps.Geocoder();
    await this.getLatLongByPostalCode();
    this.local.clearTimeout(this.timeout3);
    this.timeout3 = setTimeout(() => {
      this.map = new google.maps.Map(document.getElementById('map_biz'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 14,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62,
          },
          strictBounds: true,
        },
      });

      this.geocodePostalCode();
    }, 100);
  }

  latLongUser: any = {};
  positionString = '';
  async getLatLongByPostalCode() {
    const res = await this.local.getLatLongByPostalCode(
      this.productData?.appUser?.postalCode,
    );
    this.latLongUser = res;
    //////console.log({res})
    return res;

    // return new Promise((resolve, reject) => {
    //   this.geocoder.geocode(
    //     { address: this.productData?.appUser?.postalCode },
    //     (results: any, status: any) => {
    //       if (status === 'OK') {
    //         const location = results[0].geometry.location;
    //         const latLong = { lat: location.lat(), lng: location.lng() };
    //         this.latLongUser = latLong;
    //         resolve(latLong);
    //       } else {
    //         reject(status);
    //       }
    //     }
    //   );
    //});
  }

  markers: any = [];
  placeMarkerAndPanTo(latLng: any, userLatLong: any = {}): void {
    if (!this.markers) {
      this.markers = [];
    }
    if (typeof latLng == 'string') {
      latLng = JSON.parse(latLng);
    }
    if (typeof userLatLong == 'string') {
      userLatLong = JSON.parse(userLatLong);
    }
    const position =
      this.productData?.type == 'promote' ? latLng : this.latLongUser;
    console.log({ position }, this.productData?.type, arguments);
    this.markers.push(
      new google.maps.Marker({
        position,
        map: this.map,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62,
          },
          strictBounds: true,
        },
      }),
    );
    // Create a dummy latLong for the second marker
    if (userLatLong?.lat) {
      const dummyLatLng = { lat: userLatLong.lat, lng: userLatLong.lng };
      this.markers.push(
        new google.maps.Marker({
          position: dummyLatLng,
          map: this.map,
          icon: {
            path: 'M0,-5 L-5,5 L5,5 Z',
            scale: 1, // Reduced scale for a smaller icon
            strokeColor: '#ff834f', // pink color
            strokeWeight: 2,
            fillColor: '#ff834f', // pink color
            fillOpacity: 0.8,
          },
          restriction: {
            latLngBounds: {
              north: 1.47,
              south: 1.22,
              east: 104.05,
              west: 103.62,
            },
            strictBounds: true,
          },
        }),
      );
    }
    this.map.panTo(
      this.productData?.type == 'promote' ? latLng : this.latLongUser,
    );
  }

  async geocodePostalCode(): Promise<void> {
    // console.trace('getting pos for', this.productData?.name);
    const postalCode =
      this.productData?.postalCode || this.productData?.appUser?.postalCode;
    let prodLatLong = this.productData?.latLong;

    if (typeof prodLatLong == 'string') {
      try {
        prodLatLong = JSON.parse(prodLatLong);
      } catch (e) {
        console.error(e);
      }
    }

    if (!postalCode) {
      console.warn('postalCode is falsy for', this.productData?.name);
    }
    if (postalCode) {
      let prodLatLong = this.productData?.latLong;

      try {
        const location = await this.local.getLatLongByPostalCode(postalCode);
        console.log('locations is ', location);
        this.positionString = (
          (await this.local.getStreetNameAndSubregionForLocation({
            latLng: location,
          })) as any
        )?.streetName;

        this.placeMarkerAndPanTo(location, this.local.getUser()?.latLong);
      } catch (e) {
        console.warn(e);
      }
    } else this.placeMarkerAndPanTo(JSON.parse(prodLatLong));
  }

  deleteReport(type) {
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.customerService
          .deleteReportProduct({
            productId: this.productData.id,
            type: type,
          })
          .subscribe((resp) => {
            this.productData.reports = this.productData.reports.filter(
              (row: any) => row?.type != type,
            );
            this.toastr.success(resp.message);
          });
      }
    });
  }

  public correctSite(site: string) {
    if (site?.trim()) {
      if (site?.startsWith('https') || site?.startsWith('http')) {
        return site;
      }
      if (site?.startsWith('www')) {
        return 'https://' + site;
      }
      return 'https://www.' + site;
    }
    return '';
  }
  public get prodSite(): string {
    return this.correctSite(this.productData?.shoutWebsite);
  }
  public clickTab(index: any) {
    if (index == 5) {
      if (this.productData?.latLong) this.initMap();
    }
  }
  public get mainProductEnableMemberShop(): boolean {
    return this.mainProductData?.enableMemberShop;
  }
  private _toggleVerifyLike(item) {
    if (!item.haveILiked) {
      this.auth.toggleVerifyReaction(item.id).subscribe({
        next: () => {
          // try fix this
          if (item.haveILiked == null || item.haveILiked == undefined) {
            item.likeCounts = 0;
          }
          if (!item.haveILiked) {
            item.likeCounts += 1;
            item.haveILiked = true;
          } else {
            item.likeCounts -= 1;
            item.haveILiked = false;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something wen wrong');
        },
      });
    }
  }
  public toggleVerifyLike(item, productData) {
    if (!this.isLogin) {
      this.showLoginError('like a verification');
      return;
    }
    const ref = this.openSuggestionPopup(productData);
    if (ref instanceof NgbModalRef) {
      ref.result.then((res) => {
        if (res.added) this._toggleVerifyLike(item);
        this._loadMoreInfos();
      });
    } else if (ref instanceof MatBottomSheetRef) {
      ref.afterDismissed().subscribe((res) => {
        if (res.added) this._toggleVerifyLike(item);
        this._loadMoreInfos();
      });
    }
  }

  public checkIfLogin(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      this.isUserDisabled = user?.isDisabled;
      this.appUserId = user?.id;
      this.isLogin = user ? 1 : 0;
      this.postalCode = user?.postalCode;
      // console.log('owner checking info', this.productData?.memberId, this.profileInfo2.id, this.productData?.shoutContact, this.profileInfo2?.phone)
      this.doesUserOwnThisProduct =
        this.productData?.memberId == this.profileInfo2?.id ||
        this.productData?.shoutContact == '65' + this.profileInfo2?.phone;
    });
  }

  public handleError(event: any): void {
    (event.target as HTMLImageElement).style.backgroundImage =
      `url('../../../../../../assets/images/shop/default.png')`;
  }

  copyReferralLink() {
    this.clipboard.copy(this.refer_friend_link);
    this.toastr.success('Referral Link Copied');
  }
  public getMemberProductList() {
    this.customerService
      .getAllShopProduct({
        categoryId: '',
        subCategoryId: '',
      })
      .subscribe(
        (response: any) => {
          this.memberProductList = response.body.filter(
            (i: any) =>
              i.memberId == this.local.getUser().id &&
              i?.type == this.productData?.type,
          );
        },
        (e) => {
          this.toastr.error(e.error.message);
        },
      );
  }

  private removeImageFromHtml(html: string): string {
    if (typeof DOMParser !== 'undefined') {
      const domParser = new DOMParser();
      const docu = domParser.parseFromString(html, 'text/html');
      docu.querySelectorAll('img').forEach((img) => img.remove());

      return docu.body.innerHTML;
    } else {
      return html;
    }
  }
  public openBooking() {
    const modalRef = this.modalService.open(ShowBookingsComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance =
      modalRef.componentInstance as ShowBookingsComponent;

    const type = this.productData?.bookingType;
    componentInstance.currentSelectedTypes = [type.subcategoryType];

    componentInstance.selectedMapCategory = type;
    componentInstance.isSelectSubCat = !!type; //this.isSelectSubCat;

    // componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    //componentInstance.mapCategories = this.mapCategories;
    console.log({ type });

    // Pass the updated booking questions and data
    componentInstance.currentCategoryBookingQuestions = JSON.parse(
      type?.subcategoryType?.mapQuestions ?? '[]',
    );
    //  console.log(JSON.parse(type?.subcategoryType?.mapQuestions))
    // console.log(componentInstance.currentCategoryBookingQuestions, 'QUESTIONSD')

    componentInstance.currentCategoryTagList = [
      ...(type?.subcategoryType?.bookingMoreInfos?.tagChoices ?? []),
      type?.subcategoryType?.bookingMoreInfos?.tagUserChoices ?? [],
    ];
    componentInstance.currentCategoryBookingImageInfo =
      type?.subcategoryType?.bookingMoreInfos?.uploadedImages;

    componentInstance.productViewClicked.subscribe((product) => {
      this.productData = product;
    });
  }

  // public productTypes = new Set();
  // public currentProductCategoryAvailableTypes = []
  private loadTypeOfProduct(productData) {
    if (!productData) {
      console.warn('productData is empty', productData);
      return;
    }
    const productId = productData?.id;
    if (productId) {
      this.auth.getTypesOfProduct(productId).subscribe({
        next: (data: any) => {
          productData.productTypes = new Set(data.data.map((t) => t.typeId));
          productData.currentProductCategoryAvailableTypes = data.others;
          // console.log(productData?.currentProductCategoryAvailableTypes, "currentProductCategoryAvailableTypes")
          productData.bookingType = data.data.find(
            (type) =>
              type?.subcategoryType?.bookingMoreInfos?.tagChoices?.length ||
              type?.subcategoryType?.bookingMoreInfos?.tagUserChoices?.length ||
              type?.subcategoryType?.mapQuestions?.length,
          );
        },
        error: console.error,
      });
    }
  }
  public formattedText(productData, value) {
    if (!productData) {
      return;
    }
    return this.removeImageFromHtml(
      productData?.[value]
        ?.replace(/\n/g, '<br>')
        .replace(/<b>/g, '<b style="font-weight: 700">'),
    );
  }

  deleteProductsAttachment() {
    if (this.productData.attachmentProductsKey) {
      this.auth
        .deleteProductsAttachment(this.productData.attachmentProductsKey)
        .subscribe((response: any) => {
          this.currentModaRef ? this.currentModaRef.dismiss() : '';
          this.toastr.success(response.message);
          this.memberNotificationService.clearNotification();
        });
    }
  }
  public isUserAnAdmin;

  isAdmin = false;

  private favouriteProd(item: any, status: boolean = true, value = '') {
    let formData: any = {};

    if (item.foodId != null) {
      item.id = item.foodId;
    }
    if (this.productData?.enableMemberShop) {
      formData = {
        member_product_id: item.id,
        isAdmin: this.isAdmin,
      };
    } else {
      formData = {
        foodId: item.id,
        isAdmin: this.isAdmin,
      };
    }
    //formData['tagName'] = data;for
    formData = { ...formData };

    formData.openComment = value;
    this.auth.marketplace_favorite_product(formData).subscribe(() => {
      item.isFavorite = !item?.isFavorite;
      if (item?.isFavorite && status) {
        // this.filteredProducts[category][index].foodFavoritesCount += 1
      } else {
        if (this.profile?.favorites)
          this.profile.favorites = this.profile?.favorites?.filter(
            (row: any) => row.foodId != item.id,
          );
        // this.filteredProducts[category][index].foodFavoritesCount -= 1
      }

      if (status) {
        this.updated.emit('getProductList');
      }
      this.memberNotificationService.getNotification();
      this._loadMoreInfos();
    });
  }

  handleFavoriteProduct(item: any, status: boolean = true) {
    if (this.isLogin) {
      if (!item.isFavorite) {
        Swal.fire({
          // title: 'Add product to favorites?',
          // text:"What fo you like about this product",
          // icon: 'info',
          html: `
              <div class="custom-modal">
                <i class="fa-solid fa-heart" style="font-size: 4rem; color: var(--secondary);"></i>
                <p class="modal-text">What do you like about this product?</p>
                <textarea id="firstTextarea" class="form-control" placeholder="Write something..." maxlength="50" style="width: 100%; margin: 10px 0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; resize: vertical; min-height: 60px;"></textarea>
                <div class="${this.isAdmin ? 'd-block' : 'd-none'}">
                  <p style="margin: 10px 0 5px 0;">What do you think needs to be improved?</p>
                  <textarea class="form-control" placeholder="Additional comments..." maxlength="50" style="width: 100%; margin: 0 0 10px 0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; resize: vertical; min-height: 60px;"></textarea>
                </div>
              </div>
            `,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: 'var(--primary)',
          preConfirm: () => {
            const firstTextarea = document.getElementById(
              'firstTextarea',
            ) as HTMLTextAreaElement;
            return firstTextarea ? firstTextarea.value : '';
          },
        }).then((c) => {
          if (c.isConfirmed) {
            this.favouriteProd(item, true, c.value);
          }
        });
      } else {
        this.favouriteProd(item);
      }
    } else {
      this.showLoginError('add product in favourites');
    }
  }

  //////////////////////////////////////  Code related to member reviews /////////////////////////////////////////////////

  private readonly REVIEW_REWARD_KEY = 'REVIEW_REWARD';
  public reviewAllocatedReward = 'Loading...';

  @ViewChild('productReviewStats')
  productReviewStats: TemplateRef<any>;

  public seeProductReviewStats() {
    this.popup.openPopup(this.productReviewStats, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      forceMode: 'bs',
      noHistory: true,
    });
    //this.bottomSheet.open(this.productReviewStats, { panelClass: 'bottom-sheet-1' })
  }

  public linesInDescritpion = 0;

  @ViewChild('addGlowModal')
  public addGlowModal: TemplateRef<any>;
  public selectedGlowType = 1;
  public pointsGivenToGolden = '';

  public addGlowToProduct() {
    // if (this.isMobile) {
    //   this.currentModaRef = this.bottomSheet.open(this.addGlowModal, { panelClass: 'bottom-sheet-1' });
    // } else {
    //   this.currentModaRef = this.modalService.open(this.addGlowModal)

    // }
    this.currentModaRef = this.popup.openPopup(this.addGlowModal, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      noHistory: true,
    });
  }
  public submitAddGlow() {
    this.closeActiveModal();
    this.auth
      .addGlowPointsToProduct(
        this.productData?.id,
        Number(this.selectedGlowType),
        Number(this.pointsGivenToGolden),
      )
      .subscribe({
        next: () => {
          this.toastr.success('Points added');
        },
        error: (err) => {
          console.error(err);
          this.toastr.error(err.error.message);
        },
      });
  }

  public currentUserPoints = 'Loading...';
  private _getAssignedRewardAmount() {
    this.auth.getAssignedPointRewards().subscribe({
      error: console.error,
      next: (data) => {
        this.reviewAllocatedReward = (
          data.body.find((s) => s.action == this.REVIEW_REWARD_KEY) ?? {
            reward: 2,
          }
        ).reward;
      },
    });
  }

  public nonFoodIndexes = [0, 1, 5, 6];

  public productIsFood(productData) {
    return [11, 20, 93, 134, , 138, 9].includes(productData?.categoryId);
  }

  public openSuggestChangeModal(isImageMode = false) {
    this.currentModaRef = this.popup.openPopup(ContributeToProductComponent, {
      //forceMode: 'bs',
      bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),
      bottomSheetPanelClass: 'bottom-sheet-1',
      hasBackdrop: true,
      modalSize: 'md',
      noHistory: true,
    });

    if (this.isMobile) {
      (this.currentModaRef as MatBottomSheetRef)
        .afterDismissed()
        .subscribe(() => {
          //console.log('bottom sheet closed')
          // this.isShowingReviewModal = false;
          this._loadMoreInfos();
        });
      (this.currentModaRef as MatBottomSheetRef).instance.productData =
        this.productData;
      (this.currentModaRef as MatBottomSheetRef).instance.isImageMode =
        isImageMode;
      //this.currentModaRef?.
    } else {
      this.currentModaRef = this.currentModaRef as NgbModalRef;
      (this.currentModaRef as NgbModalRef).componentInstance.productData =
        this.productData;
      (this.currentModaRef as NgbModalRef).componentInstance.isImageMode =
        isImageMode;
      this.currentModaRef?.hidden.subscribe(() => {
        // this.isShowingReviewModal = false;
        this._loadMoreInfos();
      });
    }
  }

  public glowWouldRecommend = 0;
  public glowWhyRecommend = '';
  public glowPageNumber = 1;

  public openImage(url, { otherImages = [], cropInformation = [] }) {
    let ref = this.popup.openPopup(ImageModalComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      modalSize: 'sm',
      modalWindowClass: 'image-modal',
      noHistory: true,
      hasBackdrop: true,
    });
    let instance;
    if (this.isMobile) {
      ref = ref as MatBottomSheetRef;
      instance = ref.instance;
    } else {
      ref = ref as NgbModalRef;
      instance = ref.componentInstance;
    }
    instance.otherImages = otherImages
      .filter((img) => !!img)
      .map((img) => environment.ImageUrl + img);
    instance.imageSrc = environment.ImageUrl + url;
    instance.cropInformation = cropInformation;
  }
  @ViewChild('glowAskModal')
  glowAskModal: TemplateRef<any>;
  private isGlowModalOpen = false;

  public timerValue = 0;
  private _secsIntervalSubscription: Subscription = null;
  private _secsTimerSubscription: Subscription = null;
  public openGlowAskModal() {
    if (this.isGlowModalOpen || !this.local.getUser()) {
      return;
    }

    this.isGlowModalOpen = true;

    this.local
      .confirm({
        title: 'Product Survey',
        text: 'You have 20 seconds to read and understand this product before having to do a short survey after',
        icon: 'info',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.timerValue = 20;
          const secs = timer(20_000);
          this._secsIntervalSubscription = interval(1000)
            .pipe(takeUntil(secs))
            .subscribe(() => {
              this.timerValue -= 1;
              this.cdr.detectChanges();
            });
          this._secsTimerSubscription = secs.subscribe(() => {
            this.currentModaRef = this.popup.openPopup(this.glowAskModal, {
              bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),
              bottomSheetPanelClass: 'bottom-sheet-1',
              modalSize: 'sm',
              modalArialLabelBy: 'modal-basic-title',
              modalWindowClass: 'suggestion',
              noHistory: true,
            });
            // if (this.isMobile) {
            //   this.currentModaRef = this.bottomSheet.open(this.glowAskModal, {
            //     scrollStrategy: this.overlay.scrollStrategies.block(),
            //     panelClass: 'bottom-sheet-1',
            //   });
            // } else {
            //   this.currentModaRef = this.modalService.open(this.glowAskModal, {
            //     size: 'sm',
            //     ariaLabelledBy: 'modal-basic-title',
            //     windowClass: 'suggestion',
            //   });
            // }
          });
        } else {
          this.modalDismissAll();
        }
      });
  }

  private checkImageFileMime = (f: File) => {
    const acceptedMime = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'];
    const extension = f.type;
    //console.log(f.name, extension)

    if (!acceptedMime.includes(extension)) {
      this.local.alertInfo({
        title: 'Image format',
        message: 'We currently accept jpg/png/webp only :)',
      });
      return false;
    }
    return true;
  };

  public get showContributeBtn(): boolean {
    return (
      this.isLogin &&
      this.productData?.subRegionId == this.local.getUser()?.region
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////////

  handleChangeRecommend(productData, action) {
    // console.log('emiited', { action });
    if (!productData?.recommendedPins || action.reset) {
      productData.recommendedPins = [];
    }

    productData.recommendedPins.push(action);
  }

  changeShowImageProduct(productData, image: string) {
    if (!productData) {
      return;
    }
    productData['food_image_active'] = image;
    this._setCropInfoForCurrentImage();
  }

  async onChangeBookNowMessage(e: any) {
    this.bookNowBoxMesssage = e.target.value;
  }

  @Input()
  public linkRfererUserId: string = '';

  @ViewChild('whyReferExplanation') whyReferExplanationModal: ElementRef;
  public showReferalUnlockExplaination() {
    // this.modalService.open(this.whyReferExplanationModal, {
    //   size: 'md',
    // });
    this.popup.openPopup(this.whyReferExplanationModal, {
      forceMode: 'modal',
      modalSize: 'md',
      noHistory: true,
    });
  }

  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && this.window?.innerWidth < 767;
  }
  // public moduloIncreaseVerifiedRating() {
  //   if (!this.isAdmin()) {
  //     return;
  //   }
  //   this.auth.moduloIncreaseVerifiedRating(this.productData?.id).subscribe({
  //     next: () => {
  //       this.toastr.success('changed');
  //       this.productData.verifiedTagRating += 1;
  //       if (this.productData.verifiedTagRating > 3) {
  //         this.productData.verifiedTagRating = 1;
  //       }
  //     },
  //     error: (err) => {
  //       this.toastr.error(err.error.message);
  //     },
  //   });
  // }
  public get verifiedTagRating() {
    const rawCount = this.productData?.verifiedTagRating;
    if (rawCount) {
      if (rawCount >= 100) {
        return 3;
      }
      if (rawCount >= 10) {
        return 2;
      }
    }
    return 1;
  }

  public claimPromoCode = '';
  public claimCurrentMoreSerive() {
    this.auth
      .claimMoreSerive(
        this.linkRfererUserId,
        this.selectedMoreService.id,
        this.claimPromoCode,
      )
      .subscribe({
        next: (data: any) => {
          this.toastr.success(data.message);
          this.modalService.dismissAll();
        },
        error: (error: any) => {
          this.toastr.error(error.error.message);
        },
      });
  }

  @ViewChild('claimReferal') claimReferal: ElementRef;
  public selectedMoreService = null;

  public claimMoreService(ms) {
    this.selectedMoreService = ms;
    // this.modalService.open(this.claimReferal, {
    //   size: 'md',
    // });
    this.popup.openPopup(this.claimReferal, {
      modalSize: 'sm',
      forceMode: 'modal',
      noHistory: true,
    });
  }

  timeout4: any;
  async bookNow(
    productId,
    productName,
    sellerId,
    sellerName,
    sellerPhoneNumber,
  ) {
    this.isLoading = true;

    this.auth
      .syncBooking({
        productId: productId,
        type: 0,
        sellerId: sellerId,
        buyerId: this.profileInfo2.id,
        payload: {
          productId,
          sellerPhoneNumber,
          productName,
        },
      })
      .subscribe(async (response: any) => {
        this.productData.remainingBook.push(response.body.bookings);
      });

    this.isLoading = false;
    this.isBookNowBox = false;
    this.isMessageSent = true;
    this.local.clearTimeout(this.timeout4);
    this.timeout4 = setTimeout(() => {
      this.isMessageSent = false;
    }, 2000);
  }

  openBookNowBox() {
    this.showAlertMessage('booking');
    // this.isBookNowBox = !this.isBookNowBox;
  }
  public floorRatting(rating, total) {
    ////////console.log(arguments)
    const div = Number(rating) / (Number(total) / 5);
    if (Number.isNaN(div)) {
      return 100;
    }
    return div * 100;
  }

  async buyNow(
    productId,
    productName,
    sellerId,
    depositAmount,
    estimatedAmount,
  ) {
    var productData = {
      productId: productId,
      productName: productName,
      depositAmount: depositAmount,
      estimatedAmount: estimatedAmount,
    };

    Swal.fire({
      // title: 'Are you sure?',
      text: 'Deposit is optional and dependent on the seller. Card will be put on hold, no charges will be made.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Continue',
    }).then((result) => {
      if (result.isConfirmed) {
        var jsonproduct = JSON.stringify(productData);
        this.isLoading = true;
        let formData = new FormData();
        formData.append('id', this.appUserId); //todo this.appUserId
        formData.append('stripe_price_id', '1');
        formData.append('tokens', 'auth');
        formData.append('token', 'auth');
        formData.append('sub', jsonproduct);
        formData.append('notification_code', 'DEFAULT');
        formData.append('sub_type', '2');

        this.auth.create_stripe_checkout_url(formData).subscribe(
          (response: any) => {
            if (response.body.url != 'r') {
              this.window.location.href = response.body.url;
            } else if (response.message != '') {
              this.toastr.success(response.message);

              this.currentModaRef ? this.currentModaRef.dismiss() : '';
            }
          },
          (e) => {
            if (e.status == 400) {
              this.toastr.error(e.error.message);
            }
          },
        );
      }
    });
    //if (!confirm('We will require you to add your crediit card for Rental')) {
    //   return;
    // }

    // Convert the JSON object to a JSON string
  }
  //public ratings = []

  showImage(src, descr = '', title = '') {
    let ref = this.popup.openPopup(ImageModalComponent, {
      hasBackdrop: true,
      bottomSheetPanelClass: 'bottom-sheet-1',
      bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),

      modalSize: 'sm',
      modalWindowClass: 'image-modal',
      noHistory: true,
    });
    if (this.isMobile) {
      ref = ref as MatBottomSheetRef;
      ref.instance.imageSrc = environment.ImageUrl + src;
      ref.instance.descr = descr;
      ref.instance.isBottomSheet = true;
      ref.instance.title = title;
    } else {
      ref = ref as NgbModalRef;
      ref.componentInstance.imageSrc = environment.ImageUrl + src;
      ref.componentInstance.descr = descr;
      ref.componentInstance.title = title;
    }
  }

  async showAlertMessage(type: string = 'whatsapp') {
    if (!this.isLogin) {
      this.toastr.error('Please login first!');
      return false;
    }

    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    const detail = this.productData;
    const typeFilter = type == 'whatsapp' ? 1 : 0;
    const check = detail.remainingBook.filter(
      (row: any) => row.productId == detail.id && row?.type == typeFilter,
    );

    if (detail.remainingBook.length > 5) {
      this.toastr.error(
        'you have reached the maximum limit for sending messages',
      );
      return false;
    }

    if (this.remainingClickBook(typeFilter) == 0) {
      this.toastr.error(
        'you have reached the maximum limit for sending messages',
      );
      return false;
    }

    if (check.length > 0) {
      this.toastr.error('You can only message this person once per day');
      return false;
    }

    const label = type == 'whatsapp' ? 'Write Your Message' : 'Book Now';
    const data = await Swal.fire({
      title:
        '<span style="position: absolute;left: 20px;top: 10px;"><i class="fa-brands fa-whatsapp"></i></span>',

      html: `Are you sure you want to book product ${this.productData.name}?`,
      showCancelButton: true,
      confirmButtonText: `<i class="fa-solid fa-paper-plane"></i> ${
        type == 'whatsapp' ? 'Send' : 'Book'
      }`,
      cancelButtonText: '<i class="fa-solid fa-times"></i> Cancel',
    });

    if (data.isConfirmed) {
      Swal.fire({
        icon: 'info',
        title: 'Sending...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Simulate an API call
      this.sendData(type)
        .then(() => {
          Swal.close();
          this.toastr.success('Your message has been sent.');
        })
        .catch(() => {
          Swal.close();
          this.toastr.error('Something went wrong.');
        });
    }
  }
  openEditMyProduct(productData) {
    this.currentModaRef = this.popup.openPopup(MyProductEditComponent, {
      data: this.productData,
      bottomSheetPanelClass: 'bottom-sheet-1',
      noHistory: true,
    });
    if (this.isMobile) {
      this.currentModaRef = this.currentModaRef as MatBottomSheetRef;
      this.currentModaRef.afterDismissed().subscribe(() => {
        this._refreshData();
      });
    } else {
      this.currentModaRef = this.currentModaRef as NgbModalRef;
      this.currentModaRef.componentInstance.productData = productData;
      this.currentModaRef.hidden.subscribe(() => {
        this._refreshData();
      });
    }
  }
  // Simulated function to send data
  sendData(type: string): Promise<any> {
    return new Promise(async (resolve) => {
      if (type == 'whatsapp') {
        await this.sendMessage(
          this.productData.seller.first_name,
          this.productData.name,
          this.productData.seller.w_country_code,
          this.productData.seller.w_phone_number,
        );
      } else {
        await this.bookNow(
          this.productData.id,
          this.productData.name,
          this.productData?.adminId ?? this.productData?.memberId,
          this.productData.seller?.first_name,
          this.productData.seller?.w_phone_number,
        );
      }
      resolve('Success');
    });
  }

  timeout5: any;
  async sendMessage(sellerName, productName, countryCode, phoneNumber) {
    if (this.messsage.length <= 0) {
      return;
    }

    this.isLoading = true;
    const data = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `+65${phoneNumber}`,
      type: 'template',
      template: {
        name: 'buyer_query',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: sellerName || 'default name',
              },
              {
                type: 'text',
                text: productName,
              },
              {
                type: 'text',
                text: this.messsage,
              },
              {
                type: 'text',
                text: `${
                  this.profileInfo2?.countryCode
                    ? this.profileInfo2.countryCode
                    : '+65'
                }${this.profileInfo2.phone}`,
              },
            ],
          },
        ],
      },
    };

    const token = environment.whtsappCloudToken;

    await fetch(environment.whtsappCloudUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    this.auth
      .syncBooking({
        productId: this.productData.id,
        type: 1,
      })
      .subscribe((response: any) => {
        this.productData.remainingBook.push(response.body.bookings);
      });
    this.isLoading = false;
    this.isMessageBox = false;
    this.isMessageSent = true;
    this.local.clearTimeout(this.timeout5);
    this.timeout5 = setTimeout(() => {
      this.isMessageSent = false;
    }, 2000);
  }
  public get showReferProductIcon(): boolean {
    if (this.linkRfererUserId) {
      return false;
    }
    return this.productData?.productMoreServices?.find((s) => {
      ////////console.log(s)
      return s.allowRefer;
    });
  }
  private getMoreServiceRefferalLink(productData) {
    const user = this.local.getUser();
    const origin = this.window?.location.host;
    return `${origin}/product/${productData?.slug}-${user.id}&promo=1`;
  }

  public async copy(s: string) {
    try {
      await navigator.clipboard.writeText(s);
      this.toastr.success('Copied!');
    } catch (e) {
      this.toastr.error('Error while copying');
    }
  }

  public openShareReferLink(productData) {
    const user = this.local.getUser();
    if (!user) {
      this.toastr.error('Please login first!');
      return;
    }
    const link = this.getMoreServiceRefferalLink(productData);

    // const ref = this.modalService.open(LinkShareComponent, {
    //   size: 'sm',
    //   ariaLabelledBy: 'modal-basic-title',
    // });
    const ref = this.popup.openPopup(LinkShareComponent, {
      forceMode: 'modal',
      modalSize: 'sm',
      modalArialLabelBy: 'modal-basic-title',
      noHistory: true,
    }) as NgbModalRef;
    ref.componentInstance.linkToBeShared = link;
    ref.componentInstance.title = 'Copy Referal Link ';
  }

  public get showTelegramButton(): boolean {
    if (this.window?.location.href.includes('/biz')) {
      return !!this.productData?.seller?.w_phone_number?.trim();
    }
    return (
      this.productData?.seller?.allowTelegramContact === 1 &&
      this.productData?.seller?.w_phone_number &&
      this.productData?.seller?.buyerContact != 0 //this is since old data might allowed bot telegram and whatsapp to be turned on
    );
  }
  public get showChatNow(): boolean {
    if (!this.isPageBiz) {
      return true;
    }
    return this.productData?.bizHasBot;
  }

  remainingClickBook(type = 0) {
    const data = this.productData.remainingBook?.filter(
      (row: any) => row?.type == type,
    );
    return 3 - (data?.length ?? 0);
  }

  async onChangeMessage(e: any) {
    this.messsage = e.target.value;
  }
  public reactToProductEmployee(emp) {
    this.auth.reactToProductEmployee(emp.id).subscribe({
      next: () => {
        emp.haveILiked = !emp.haveILiked;
        if (emp.haveILiked) {
          emp.likedCount += 1;
        } else {
          emp.likedCount -= 1;
        }
        this.cdr.detectChanges();
      },
      error: console.error,
    });
  }

  redirectLink(bypass = false) {
    //////console.log("opening link")
    const url =
      'https://wa.me/' +
      (this.productData?.type == 'promote'
        ? this.productData?.shoutContact
        : this.productData?.seller?.w_phone_number);

    if (bypass || !this.productData?.enableMemberShop) {
      Swal.fire({
        icon: 'info',
        text: `This will open direct WhatsApp link`,
        showCancelButton: true,
        confirmButtonColor: 'var(--primary)',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
      }).then((resp) => {
        if (resp.isConfirmed) {
          this.window?.open(url, '_blank');
        }
      });
      return;
    }
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }

    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.errorChatURL = false;

    if (url != '' && url != null) {
      const detail = this.productData;
      const typeFilter = 1;
      const check = detail.remainingBook.filter(
        (row: any) => row.productId == detail.id && row?.type == typeFilter,
      );

      if (detail.remainingBook.length > 5) {
        this.toastr.error(
          'you have reached the maximum limit for sending messages',
        );
        return false;
      }

      if (this.remainingClickBook(typeFilter) == 0) {
        this.toastr.error(
          'you have reached the maximum limit for sending messages',
        );
        return false;
      }

      if (check.length > 0) {
        this.toastr.error('You can only message this person once per day');
        return false;
      }
      return Swal.fire({
        text: `This will open direct WhatsApp link (${this.remainingClickBook(
          1,
        )})`,
        showCancelButton: true,
        confirmButtonColor: 'var(--primary)',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
      }).then((resp) => {
        if (resp.isConfirmed) {
          this.window?.open(url, '_blank');
          this.auth
            .addChatNotification(
              (this.productData.appUser ?? this.productData.seller).id,
              'whatsapp',
            )
            .subscribe({
              next: () => {},
            });
          this.auth
            .syncBooking({
              productId: this.productData.id,
              type: 1,
            })
            .subscribe((response: any) => {
              this.productData.remainingBook.push(response.body.bookings);
            });
        }
      });
    } else this.errorChatURL = true;
    this.errorChatURL = this.errorChatURL;
  }

  public async submitReport(): Promise<void> {
    // if (this.isLogin == 0) {
    //   this.toastr.error('Please Login First !');
    //   return;
    // }
    const clientIp = this.commonService.clientIp;

    let message = this.memberMessage.trim();
    if (message) {
      let payload: any = {
        message: message,
        product_id: this.productData.id,
        type: this.type,
        category: 'biz_product',
        clientIp: clientIp,
      };
      if (this.productData?.enableMemberShop) {
        payload = {
          message: message,
          member_product_id: this.productData.id,
          type: this.type != '' ? this.type : this.reportType,
          category: 'product',
          clientIp: clientIp,
        };
      }

      const user = this.productData?.appUser ?? this.productData?.seller;
      payload.sellerId = user?.id;

      this.auth.submitReportMessage(payload).subscribe({
        next: (response: any) => {
          this.toastr.success(response.message);
          this.currentModaRef.dismiss();
          this.productData.isReported = 1;
          this.type = '';
          this.memberNotificationService.getNotification();
        },
        error: (e) => {
          this.toastr.error(e.error.message);
        },
      });
    } else {
      this.toastr.error('Report is empty!');
    }
  }

  openSuggestModal(modal: any, type: any = '') {
    this.memberMessage = '';
    this.currentModaRef = this.popup.openPopup(modal, {
      bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),
      bottomSheetPanelClass: 'bottom-sheet-1',
      modalSize: 'sm',
      modalArialLabelBy: 'modal-basic-title',
      modalWindowClass: 'suggestion',
      noHistory: true,
    });
    // if (this.isMobile) {
    //   this.currentModaRef = this.bottomSheet.open(modal, {
    //     scrollStrategy: this.overlay.scrollStrategies.block(),
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.currentModaRef = this.modalService.open(modal, {
    //     size: 'sm',
    //     ariaLabelledBy: 'modal-basic-title',
    //     windowClass: 'suggestion',
    //   });
    // }
    this.type = type;
  }

  openReportModal(modal: any, type: any = '') {
    this.memberMessage = '';

    // if (this.isMobile) {
    //   this.currentModaRef = this.bottomSheet.open(modal, {
    //     scrollStrategy: this.overlay.scrollStrategies.block(),
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.currentModaRef = this.modalService.open(modal, {
    //     size: 'sm',
    //     ariaLabelledBy: 'modal-basic-title',
    //     windowClass: 'suggestion',
    //   });
    // }
    this.currentModaRef = this.popup.openPopup(modal, {
      bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),
      bottomSheetPanelClass: 'bottom-sheet-1',
      modalSize: 'sm',
      modalArialLabelBy: 'modal-basic-title',
      modalWindowClass: 'suggestion',
      noHistory: true,
    });
    this.type = type;
  }

  saveSeletedImage(event) {
    let file = event.target.files[0];
    if (!this.checkImageFileMime(file)) {
      return;
    }

    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.suggestionBase64 = fileReader.result;
      this.suggestionAttachment = file;
    };
    fileReader.readAsDataURL(file);
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  private get isPageBiz(): boolean {
    return this.window?.location.href.includes('/biz');
  }

  public openTelegramAccount(phoneNumber: string | number) {
    if (!phoneNumber) {
      console.error('empty phoner number given!');
      return;
    }
    if (typeof phoneNumber != 'number' && typeof phoneNumber != 'string') {
      console.error('invalid type!');
      return;
    }
    this.window?.open(
      `https://t.me/${this.isPageBiz ? '' : '+65'}${phoneNumber}`,
      '_blank',
    );
  }
  async handleTelegram(itemId) {
    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.auth
      .addChatNotification(
        (this.productData.appUser ?? this.productData.seller).id,
        'book-now',
      )
      .subscribe({
        next: () => {},
      });

    this.currentModaRef = this.popup.openPopup(BookTimingModalComponent, {
      forceMode: 'modal',
      modalWindowClass: 'my-modal sm book-timiing',
      modalSize: 'sm',
      noHistory: true,
    }) as NgbModalRef;
    // this.modalService.open(
    //   BookTimingModalComponent,
    //   {
    //     windowClass: 'my-modal sm book-timing',
    //     size: 'sm',
    //   }
    // );
    this.currentModaRef.componentInstance.productData = this.productData;

    const productDataChangeListener = () => {
      let instance =
        (this.currentModaRef as NgbModalRef).componentInstance ??
        (this.currentModaRef as MatBottomSheetRef).instance;
      instance.productData = this.productData;
    };
    this.onChangeListeners.push(productDataChangeListener);
    const dismissFunc = () => {
      const idx = this.onChangeListeners.indexOf(productDataChangeListener);
      if (idx !== -1) {
        this.onChangeListeners.splice(idx, 1);
      }
    };

    this.currentModaRef.closed.subscribe(dismissFunc);
    this.currentModaRef.dismissed.subscribe(dismissFunc);

    // await this.telegramPost(itemId)
    //this.modal.close();e
  }

  // async telegramPost(itemId) {

  //   const login = this.local.getUser();

  //   if (!login) return this.toastr.error('Please Login First!');

  //   const user = this.productData?.appUser ?? this.productData?.seller;
  //   if (login.id == user?.id) {
  //     this.toastr.error("It's your product")
  //     return
  //   }
  //   const token = login.token;
  //   const URL = environment.ImageUrl+ 'api/postToTelegramChannels';
  //   // await fetch(URL, {method: 'POST'})
  //   this.http.post(URL, {
  //     itemId
  //   }, {
  //     headers: {
  //       'Authorization': `Bearer ${token}`
  //     }
  //   })
  //   .subscribe(
  //     data =>{
  //        this.toastr.show("Posted!")
  //     },
  //     err =>{
  //       this.toastr.error("Error: " + err.error.error)
  //     }
  //   )

  // }

  openChat(params) {
    this.sharedService.triggerChatNow(params);
  }

  async handleChatNow() {
    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.modalDismissAll();
    const params = {
      chatingNow: user?.id,
      menu: 'chat',
      chatTitle: user.profileCharacterName ?? 'User',
      lastSeenTime: user.lastSeenTime ?? '...',
      productName: this.productData.name,
      productImage: this.productData.food_image_active,
      productPrice: this.productData.costPrice,
      productId: this.productData.id,
      isBiz: this.window?.location.href.indexOf('/biz') != -1,
      isFirstMessageFromChatNow:
        this.window?.location.href.indexOf('/biz') == -1,
    };

    if (this.window?.location.href.indexOf('/biz') != -1) {
      this.auth.get_chat_data(user?.id, true).subscribe({
        next: (data) => {
          if (data['chatData']['doesBizHaveABot']) {
            this.openChat(params);
          } else {
            this.toastr.info('Biz Owner has not registered a telegram account');
          }
        },
        error: (err) => {
          this.toastr.error('Something went wrong please try again latter');
        },
      });
    } else {
      this.openChat(params);
    }

    //this.sharedService.triggerChatNow({ chatingNow: user?.id, menu: 'chat', chatTitle: user.profileCharacterName ?? "User" });
    // this.auth
    //   .chatCheckChannel({
    //     sellerId: user.id,
    //     productId: this.productData.id,
    //   })
    //   .subscribe((response: any) => {
    //     const result = response.body;
    //     this.modalDismissAll();
    //     this.sharedService.triggerChatNow({ menu: 'chat' });
    //     this.productData['foodSpecs'] =
    //       this.productData?.memberShopProductsVariations || [];

    //     const resultsConverter = {
    //       name: this.productData.name,
    //       description: this.productData.description,
    //       seller_info: this.productData.seller_info,
    //       delivery: this.productData.delivery,
    //       image: this.productData.memberShopProductsImages[0].image,
    //       sellerName: user.profileCharacterName ?? 'Admin Shop',
    //       sellerImage: user.profileCharacterImageFile ?? 'Admin Shop',
    //       variations: this.productData.foodSpecs.map((row: any) => {
    //         return {
    //           price: row.key,
    //           name: row.value,
    //           currency: '$',
    //           unit: row.nKey,
    //         };
    //       }),
    //     };

    //     setTimeout(() => {
    //       this.sharedService.triggerInitSeller({
    //         ...this.productData.appUser,
    //         channel: result,
    //         product_name: this.productData.name,
    //         product_image: this.imgUrl + this.productData?.primaryImage,
    //         params: {
    //           seller_id: user.id,
    //           product_id: this.productData.id,
    //           query: 'Send me price list for this product',
    //           product_details: JSON.stringify(resultsConverter),
    //         },
    //       });
    //     }, 100);
    //   });
  }

  //************************* Code related to adding new promo on a product ***********/
  public isAddPromoVisible = false;
  @ViewChild('addAdsInProduct')
  public addAdsInProduct: TemplateRef<any>;
  public currentlyAddingPromoToProduct = null;
  public openAdInProductModal(pd) {
    this.currentlyAddingPromoToProduct = pd;
    this.currentModaRef = this.popup.openPopup(this.addAdsInProduct, {
      bottomSheetScrollStrategy: this.overlay.scrollStrategies.block(),
      bottomSheetPanelClass: 'bottom-sheet-1',
      noHistory: true,
    });
    // if (this.isMobile) {
    //   this.currentModaRef = this.bottomSheet.open(this.addAdsInProduct, {
    //     scrollStrategy: this.overlay.scrollStrategies.block(),
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.modalService.open(this.addAdsInProduct);
    // }
  }

  private getImageByAccessor(images, accessor) {
    const imageObj = images?.find((o) => o.imageAccessor === accessor);
    return imageObj ? imageObj.image : '';
  }
  J(o) {
    return '';
    //console.log(o);

    //return '{X}';
    //return JSON.stringify(o);
  }

  timeout6: any;
  private loadOtherImagesOfProduct(productData) {
    ////console.log('getting of', productData.name, productData.memberShopProductsImages)
    const variants = productData?.memberShopProductsVariations || [];
    variants.sort((variantOne, variantTwo) => {
      return variantOne.likedCount < variantTwo.likedCount;
    });

    this.timeout6 = setTimeout(() => (productData['foodSpecs'] = variants));

    productData['food_image_1'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image1',
    );
    productData['food_image_active'] = productData['food_image_1'];
    productData['food_image_2'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image2',
    );
    productData['food_image_3'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image3',
    );
    productData['food_image_4'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image4',
    );
  }

  public likeVariant(variant) {
    this.openSuggestChangeModal();
  }

  public availableExpiryIntervals = ['1 Week', '1 Month', '2 Month'];
  // public saveNewPromoOnProduct() {
  //   const fd = new FormData();
  //   const payload = {
  //     serviceComment: this.newPromoServiceComment,
  //     serviceDescription: this.newPromoServiceDescription,
  //     iconText: this.newPromoIconText,
  //     expiryInString: this.newPromoExpiryInString,
  //     allowRefer: this.newPromoAllowRefer,
  //     referAmount: this.newPromotReferAmount,
  //     imageAttachName: this.newPromoImageAttachName,
  //   };
  //   for (const payloadField in payload) {
  //     fd.append(payloadField, payload[payloadField]);
  //   }
  //   fd.append('productId', this.productData?.id);
  //   fd.append(this.newPromoImageAttachName, this.newPromoSelectedImage);

  //   this.auth.addPromoOnProduct(fd).subscribe({
  //     next: () => {
  //       this.toastr.success('Promo Added!');
  //       this._resetNewPromoFields();
  //       this.modalService.dismissAll();
  //     },
  //     error: (err) => {
  //       console.error(err);
  //       this.toastr.error(err.error.message);
  //     },
  //   });
  // }

  /********************************************************************************** */

  openMemberLinkPopup(e: any, modal, foodId, type) {
    e.preventDefault();
    this.isTypeReferral = type;
    if (this.isLogin == 1) {
      // this.currentModaRef = this.modalService.open(modal, {
      //   size: 'sm',
      //   ariaLabelledBy: 'modal-basic-title',
      //   windowClass: 'member_link_pop',
      // });
      this.currentModaRef = this.popup.openPopup(modal, {
        modalSize: 'sm',
        modalWindowClass: 'member_link_pop',
        forceMode: 'modal',
        modalArialLabelBy: 'modal-basic-title',
        noHistory: true,
      });
      this.get_marketplace_referral_store_link(foodId, type);
    } else {
      if (type == 'referral') {
        this.toastr.warning('Please login to open referral link.');
      } else {
        this.toastr.warning('Please login to open store link.');
      }
    }
  }

  get_marketplace_referral_store_link(foodId, type) {
    (this.productData?.enableMemberShop
      ? this.auth.getMarketplaceReferralStoreLink(foodId)
      : this.auth.get_marketplace_referral_store_link(foodId)
    ).subscribe(
      (response: any) => {
        if (response.body.isStoreLink == 1) {
          this.store_link_prefix = response.body.referFriendLink;
          this.createReferralLink(
            response.body.clientId,
            response.body.appUserId,
            type,
            this.store_link_prefix,
          );
        } else {
          this.store_link_prefix = this.default_store_link_prefix;
          this.createReferralLink(
            response.body.clientId,
            response.body.appUserId,
            type,
            this.store_link_prefix,
          );
        }
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }
      },
    );
  }

  createReferralLink(clientId, appUserId, type, storeLinkPrefix) {
    let urlParams = '';
    if (type == 'referral') {
      urlParams = `referral_${clientId}_${appUserId}`;
    } else {
      urlParams = `normal_${clientId}`;
    }
    const urlParamsEnc = urlParams;
    const urlParamsEncUrl = encodeURIComponent(urlParamsEnc);
    const urlOrigin = `https://${storeLinkPrefix}/#/mobile/${urlParamsEncUrl}`;
    this.refer_friend_link = urlOrigin;
  }

  public isSelected(date: NgbDateStruct): boolean {
    return this.productData?.selectedHolidays
      ? this.productData?.selectedHolidays.some((d) => this.dateEquals(d, date))
      : false;
  }

  dateEquals(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return (
      date1.year === date2.year &&
      date1.month === date2.month &&
      date1.day === date2.day
    );
  }

  handleHideProduct() {
    this.checkIfLogin();
    if (this.productData?.hiddenBy.includes(this.appUserId)) {
      this.toastr.error('maximum 1 time for request');
      return;
    }
    this.local
      .alertConfirm({
        message: `Are you sure want to hide this product ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth
            .hideMemberShopProduct({ productId: this.productData?.id })
            .subscribe(
              (resp: any) => {
                Swal.close();
                this.toastr.success(resp.message);
                this.productData?.hiddenBy.push(this.appUserId);
                // if(this.productData?.hiddenBy?.length >= 5) {

                // }
              },
              (e) => {
                Swal.close();
                // this.toastr.error(e.error.message)
              },
            );
        }
      });
  }
  public editMemberProduct() {
    if (this.addProductComponent) {
      this.addProductComponent.memberShopProductType = this.productData?.type;
      this.addProductComponent.selectedCatId = this.productData?.categoryId;
      this.addProductComponent.selectedCategoryNameForDD =
        this.productData?.categoryName;
      this.addProductComponent.selectedsubCatId =
        this.productData?.subCategoryId;
      this.addProductComponent.selectedSubCategoryName =
        this.productData?.subCategoryName;
      this.addProductComponent.editProductModal(this.productData?.id);
      this.addProductComponent.productDataChanged.subscribe(() => {
        let obsver;
        if (!this.mainProductEnableMemberShop) {
          let formData = new FormData();
          formData.append('foodId', this.productData?.id);
          obsver = this.auth.get_food_details(formData);
        } else {
          obsver = this.auth.getShopProductDetails({
            productId: this.productData?.id,
          });
        }
        obsver.subscribe((data) => {
          this.productData = data.body;
          this._loadMoreInfos();
        });
      });
    }
  }
  private _refreshData() {
    this.auth
      .getShopProductDetails({
        productId: this.productData?.id,
      })
      .subscribe((data) => {
        this.productData = data.body;
        this._loadMoreInfos();
        this.cdr.detectChanges();
      });
  }

  public deleteMemberProduct() {
    this.addProductComponent.delete_food(this.productData?.id);
  }

  openBizLink(isPromote = false) {
    if (isPromote) {
      this.window?.open(this.hrefContact(this.productData.shoutLink), '_blank');
      return;
    }

    if (
      this.productData?.seller?.shop_name == 'null' ||
      this.productData?.seller?.shop_name == ''
    ) {
      this.productData.seller.shop_name = null;
    }
    this.router.navigate(['/biz/shop', this.productData?.adminId]);
  }

  public priceCheck(value) {
    return parseFloat(value) ? '$' + parseFloat(value) : '';
  }

  public showLoginErr = false; //login error should not be shown immediatly but when there is come
  public loginErrorReason = '';
  showLoginError(reason) {
    this.loginErrorReason = reason;
    this.showLoginErr = true;

    document.getElementById('login-err').scrollIntoView();
  }

  loginHere() {
    //this.modalService.dismissAll();
    document.getElementById('loginBtn')?.click();
    this.showLoginErr = true;
    this.sharedService.openLoginSubject.next()
    // this.auth.increaseLoginBecauseOfProductCount(this.productData.id).subscribe({
    //   error: console.error,
    //   next:  () => //////console.log("login count increased")
    // })
  }

  selectedAttachProduct: any = null;
  public attachMemberProduct(modal: any, productId: any): void {
    if (!this.productData.attachmentProducts) {
      this.selectedAttachProduct = productId;
      // this.currentModaRef = this.modalService.open(modal, {
      //   size: 'sm',
      //   ariaLabelledBy: 'modal-basic-title',
      //   windowClass: 'suggestion',
      // });
      this.currentModaRef = this.popup.openPopup(modal, {
        modalSize: 'sm',
        modalArialLabelBy: 'modal-basic-title',
        modalWindowClass: 'suggestion',
        noHistory: true,
      });
      this.getMemberProductList();
    } else {
      this.toastr.error('Only one product can be added!');
    }
  }

  public attachProduct(productId: any) {
    if (this.selectedAttachProduct == productId) {
      this.toastr.error('Both Product Cannot b same!');
      return;
    }

    this.endTime = this.endTime
      ? moment(new Date()).add(parseInt(this.endTime), 'days').valueOf()
      : '';
    let payload = {
      parentProductId: this.selectedAttachProduct,
      childProductId: productId,
      description: '',
    };
    if (this.endTime) {
      payload['attachmentEndTime'] = this.endTime;
    }

    this.auth.addProductsAttachment(payload).subscribe((response: any) => {
      this.currentModaRef ? this.currentModaRef.dismiss() : '';
      this.toastr.success(response.message);
      this.memberNotificationService.clearNotification();
      this.productData['attachmentProducts'] = productId;
    });
  }
  public submitSuggestion() {
    // if (this.isLogin == 0) {
    //   return this.toastr.error('Please Login First !');
    // }
    let formData = new FormData();
    let message = this.memberMessage.trim();
    formData.append('message', message);
    this.productData?.enableMemberShop
      ? formData.append('member_product_id', this.productData.id)
      : formData.append('product_id', this.productData.id);
    formData.append('type', this.type);

    if (message) {
      this.auth.submitSuggestionMessage(formData).subscribe((response: any) => {
        this.type = '';
        this.toastr.success(response.message);
        this.currentModaRef.dismiss();
      });
    } else {
      this.toastr.error('Suggestion is empty!');
    }
  }

  shareContent(event) {
    event.stopPropagation();
    if (navigator.share) {
      // Get the image URL from the img element
      const imgElement = document.querySelector('img.main-image');
      //@ts-ignore
      const imgUrl = imgElement?.src;

      if (imgUrl) {
        // Fetch the image from the URL and convert it to a blob
        fetch(imgUrl)
          .then((res) => res.blob())
          .then((blob) => {
            // Create a file from the blob
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });

            // Now share the file along with other details
            navigator
              .share({
                title: this.productData?.name || 'Check this out!',
                text: '', //text: this.getRating() || 'See this amazing product!',
                url: this.window?.location.href || '', // The URL you want to share
                files: [file], // Attach the image file
              })
              .then(() => {})
              .catch((error) => {
                // console.error('Error sharing:', error);
              });
          })
          .catch((error) => {
            // console.error('Error fetching the image:', error);
          });
      } else {
        // console.error('Image not found');
      }
    } else {
      alert('Web Share API is not supported in your browser.');
    }
  }

  public getRating(): string {
    let rating = '';
    if (
      this.productData?.sellerInformation?.googleReviewRating ||
      this.productData?.sellerInformation?.googleReviewCount ||
      this.productData?.sellerInformation?.googleReviewCount
    ) {
      rating +=
        (this.productData?.sellerInformation?.googleReviewRating + ' Star' ||
          '') +
        ' Google ' +
        (this.productData?.sellerInformation?.googleReviewCount
          ? '(' + this.productData?.sellerInformation?.googleReviewCount + ')'
          : '');
    }

    if (
      this.productData?.sellerInformation?.carousellReviewRating ||
      this.productData.sellerInformation?.carousellReviewCount ||
      this.productData?.sellerInformation?.carousellReviewCount
    ) {
      rating +=
        (this.productData?.sellerInformation?.carousellReviewRating + ' Star' ||
          '') +
        'Carousell ' +
        (this.productData.sellerInformation?.carousellReviewCount
          ? '(' +
            this.productData?.sellerInformation?.carousellReviewCount +
            ')'
          : '');
    }

    return rating;
  }

  public get verifiedStyle() {
    const len = this.verifiedTag?.length;

    return `position: relative; left: ${len * 0.08 + 2}rem; gap: .4em;`;
  }
  public get verifiedTag() {
    return (
      this.productData?.verifiedTag?.trim()?.length
        ? this.productData.verifiedTag
        : 'Verified'
    ).toLowerCase();
  }

  public openHolidayPopUp(modal) {
    // this.modalService.open(modal, {
    //   size: 'sm',
    //   ariaLabelledBy: 'modal-basic-title',
    //   windowClass: 'suggestion',
    // });
    this.popup.openPopup(modal, {
      modalSize: 'sm',
      modalArialLabelBy: 'modal-basic-title',
      modalWindowClass: 'suggestion',
      forceMode: 'modal',
      noHistory: true,
    });
  }

  public isArray(input) {
    return Array.isArray(input);
  }

  public goToProfileDetail() {
    if (
      this.productData?.appUser?.profileCharacterName == 'null' ||
      this.productData?.appUser?.profileCharacterName == ''
    ) {
      this.productData.appUser.profileCharacterName = null;
    }
    this.router.navigateByUrl(
      `/profile/${
        this.productData?.appUser?.profileCharacterName ??
        this.productData?.appUser?.referralCode
      }`,
    );
  }

  public redirectToProduct(input) {
    let currentUrl = this.productData.enableMemberShop ? '/' : '/biz';
    let product = input?.name.trim().toLowerCase().replace(/ /g, '-');

    this.router.navigateByUrl(`/${currentUrl}?product=${product}-${input?.id}`);
  }

  openRecommendation(pin) {
    this.sharedService.triggerOpenExperience(pin);
  }

  hrefContact(url: string) {
    if (!url.startsWith('https')) {
      url = url.replace('http://', 'https://');
    } else if (!url.startsWith('https') && !url.startsWith('http')) {
      url = 'https://' + url;
    } else if (url.startsWith('https//')) {
      url = url.replace('https//', 'https://');
    } else if (url.startsWith('http//')) {
      url = url.replace('http//', 'https://');
    }
    return url;
  }

  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    this.local
      .confirm({
        title: 'Support',
        text: `Do you wish to Support this business?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.productData?.appUser?.id,
              type: 'community',
            })
            .subscribe({
              next: (response: any) => {
                this.productData.appUser.isSupport =
                  !this.productData.appUser.isSupport;
                this.toastr.success(response.message);
              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }

  handleUnreport() {
    this.local
      .confirm({
        title: 'Unreport',
        text: `Do you wish to Unreport this product?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService.markAsUnreport(this.productData?.id).subscribe({
            next: (response: any) => {
              this.productData.isReported = !this.productData.isReported;
              this.toastr.success(response.message);
            },
            error: (e) => {
              this.toastr.error(e.error.message);
            },
          });
        } else {
          this.toastr.info('Unreport cancelled');
        }
      });
  }
  getTags(list: any): string[] {
    return (list || '')
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t !== '');
  }
}
